<nav class="navBar" v-if="isLoggedIn">
  <template v-if="!isMobile">
    <div class="nav-container">
      <!-- <form class="form-inline">
        <input
          class="form-control mr-sm-2"
          type="search"
          placeholder="¿Qué deseas buscar?"
          aria-label="Search"
          disabled
        />
      </form> -->
      <div class="nav-end">
        <button class="button-log-out" type="submit" @click="handleSignOut">
          <img src="@/assets/icons/logout.svg" />
          Cerrar Sesión
        </button>
      </div>
    </div>
  </template>
  <template v-if="isMobile">
    <div class="mobile-nav-container">
      <div class="mobile-sidebar-toggle" @click="toggleMobileSidebar">
        <i class="fas fa-bars"></i>
      </div>

      <img
        src="@/assets/images/logo-new.png"
        alt="logo"
        class="logo-mobile"
        @click="goToHome"
      />
      <div class="nav-end">
        <div class="avatar-circle">
          <span class="avatar-initials">{{ getUserInitials() }}</span>
        </div>
      </div>
    </div>
  </template>
</nav>
